import MenuList from './List';
import MenuForm from './Form';

export default {
    path: 'cadastros',
    redirect: '/cadastros/menus',
    name: 'Cadastro Menus',
    component: {
        render (c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'menus',
            name: 'list-menu',
            component: MenuList,
            meta: {
                requiresAuth: true,
                label: 'Listar Menus'
            }
        },
        {
            path: 'menus/novo',
            name: 'new-menu',
            component: MenuForm,
            meta: {
                requiresAuth: true,
                label: 'Novo Menu'
            }
        },
        {
            path: 'menus/:id',
            name: 'edit-menu',
            component: MenuForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Menu'
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/views/menu/router.js